/* eslint-disable node/no-unsupported-features/es-syntax */
import { SALARY_ROUTE_NAMES } from "@/shared";
export const SALARY_ROUTES = [
    {
        name: SALARY_ROUTE_NAMES.LIST,
        path: "/employee/salary",
        meta: {
            title: "words.salary",
        },
        component: () => import("../ui/SalaryList.vue"),
    },
    {
        name: SALARY_ROUTE_NAMES.HISTORY,
        path: "/employee/salary/history",
        meta: {
            title: "words.salary_history",
        },
        component: () => import("../ui/SalaryHistory.vue"),
    },
    {
        name: SALARY_ROUTE_NAMES.EDIT,
        path: "/employee/salary/edit/:salaryId",
        meta: {
            title: "words.edit_salary",
        },
        component: () => import("../ui/SalaryEdit.vue"),
        props: true,
    },
];
